import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AccountDetailComponent } from './account/account-detail/account-detail.component';
import { CustomRouteReuseStrategy } from './app-routing.reuse-strategy';
import { InvoiceDetailComponent } from './invoice/invoice-detail/invoice-detail.component';
import { InvoiceListComponent } from './invoice/invoice-list/invoice-list.component';
import { OrderProcessComponent } from './order-process/order-process.component';
import { OrderDetailComponent } from './order/order-detail/order-detail.component';
import { OrderListComponent } from './order/order-list/order-list.component';
import { PortalOrderDetailComponent } from './portal-order/portal-order-detail/portal-order-detail.component';
import { PortalOrderListComponent } from './portal-order/portal-order-list/portal-order-list.component';
import { SelectAccountComponent } from './select-account/select-account.component';
import { companyAdminConfigurationResolver } from './shared/router-resolvers/company-admin-configuration.resolver';
import { canDeactivateGuard } from './shared/security/guards/can-deactivate.guard';
import { contextGuard } from './shared/security/guards/context.guard';
import { createOrdersGuard } from "./shared/security/guards/create-orders.guard";
import { portalAccessGuard } from './shared/security/guards/portal-access.guard';
import { UserWithoutRolesComponent } from './user-without-roles/user-without-roles.component';

const routes: Routes = [
  {
    path: 'account/:customerAxCode',
    component: AccountDetailComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/draftorder',
    component: OrderProcessComponent,
    //createOrdersGuard contains the contextGuard
    canActivate: [MsalGuard, portalAccessGuard, createOrdersGuard],
    canDeactivate: [canDeactivateGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/draftorder/:id',
    component: OrderProcessComponent,
    //createOrdersGuard contains the contextGuard
    canActivate: [MsalGuard, portalAccessGuard, createOrdersGuard],
    canDeactivate: [canDeactivateGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/openorders',
    component: PortalOrderListComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/openorders/:id',
    component: PortalOrderDetailComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/orders',
    component: OrderListComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/orders/:id',
    component: OrderDetailComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/invoices',
    component: InvoiceListComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  {
    path: 'account/:customerAxCode/invoices/:id',
    component: InvoiceDetailComponent,
    canActivate: [MsalGuard, portalAccessGuard, contextGuard],
    resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  },
  // {
  //   path: 'account/:customerAxCode/products',
  //   component: ProductListComponent,
  //   canActivate: [MsalGuard, contextGuard, portalAccessGuard],
  //   resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  // },
  // {
  //   path: 'account/:customerAxCode/products/:id',
  //   component: ProductDetailComponent,
  //   canActivate: [MsalGuard, contextGuard, portalAccessGuard],
  //   resolve: { companyAdminConfiguration: companyAdminConfigurationResolver }
  // },
  {
    path: 'security',
    component: UserWithoutRolesComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '',
    component: SelectAccountComponent,
    canActivate: [MsalGuard, portalAccessGuard]
  },
  {
    path: '**', component: SelectAccountComponent,
    canActivate: [MsalGuard, portalAccessGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  ]
})
export class AppRoutingModule { }
